import * as constants from '../../constants.json'

export const transportModeTypeEnum = Object.freeze(constants.transportModeTypeEnum)
export const directionTypeEnum = Object.freeze(constants.directionTypeEnum)
export const dollyTypeEnum = Object.freeze(constants.dollyTypeEnum)
export const shippingCoinEnum = Object.freeze(constants.shippingCoinEnum)
export const freightAddressEnum = Object.freeze(constants.freightAddressEnum)
export const insuranceExtrasEnum = Object.freeze(constants.insuranceExtrasEnum)
export const incotermsEnum = Object.freeze(constants.incotermsEnum)
export const inlandTransportationEnum = Object.freeze(constants.inlandTransportationEnum)
